





















































































































































































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

import CardComponent from '@/modules/core/components/CardComponent.vue';
import DeviceConnectionIndicator from '../components/DeviceConnectionIndicator.vue';
import DeviceUnassignBtn from '../components/DeviceUnassignBtn.vue';
import DeviceResetSubscriptionToBaseBtn from '../components/DeviceResetSubscriptionToBaseBtn.vue';
import DeviceSyncConfigBtn from '../components/DeviceSyncConfigBtn.vue';
import BatteryLevel from '../components/BatteryLevel.vue';

@Component({
  components: {
    CardComponent,
    DeviceConnectionIndicator,
    DeviceUnassignBtn,
    DeviceResetSubscriptionToBaseBtn,
    DeviceSyncConfigBtn,
    BatteryLevel,
  },
})
export default class Device extends Vue {
  @Prop({
    default: null,
  })
  public initialDevice: any;

  public syncingDevice = false;

  public get device(): any {
    return this.initialDevice;
  }

  public get cardTitle(): string {
    return `Terminal ${this.device.incrementalId}`;
  }
}
